module.exports = __webpack_public_path__ + "static/img/f_2.cbab189b.png";